import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BlockUIModule } from 'primeng/blockui';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { CardModule } from 'primeng/card';
import { CheckboxModule } from 'primeng/checkbox';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { DropdownModule } from 'primeng/dropdown';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputTextModule } from 'primeng/inputtext';
import { MenuModule } from 'primeng/menu';
import { ProgressBarModule } from 'primeng/progressbar';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { RippleModule } from 'primeng/ripple';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { SidebarModule } from 'primeng/sidebar';
import { TableModule } from 'primeng/table';
import { TabMenuModule } from 'primeng/tabmenu';
import { ToastModule } from 'primeng/toast';
import { RadioButtonModule } from 'primeng/radiobutton';
import { CarouselModule } from 'primeng/carousel';
import { ChartModule } from 'primeng/chart';
import { DialogModule } from 'primeng/dialog';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { PanelModule } from 'primeng/panel';
import { PanelMenuModule } from 'primeng/panelmenu';
import { PasswordModule } from 'primeng/password';
import { PickListModule } from 'primeng/picklist';
import { SelectButtonModule } from 'primeng/selectbutton';
import { SliderModule } from 'primeng/slider';
import { EditorModule } from 'primeng/editor';
import { GalleriaModule } from 'primeng/galleria';
import { TreeTableModule } from 'primeng/treetable';
import { AccordionModule } from 'primeng/accordion';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { AvatarModule } from 'primeng/avatar';
import { ImageModule } from 'primeng/image';
import { MultiSelectModule } from 'primeng/multiselect';
import { RatingModule } from 'primeng/rating';
import { ScrollTopModule } from 'primeng/scrolltop';
import { TagModule } from 'primeng/tag';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { StepsModule } from 'primeng/steps';
import { SkeletonModule } from 'primeng/skeleton';
import { DragDropModule } from 'primeng/dragdrop';
import { CascadeSelectModule } from 'primeng/cascadeselect';
import { DividerModule } from 'primeng/divider';
import { StepperModule } from 'primeng/stepper';
import { MessagesModule } from 'primeng/messages';
import { FileUploadModule } from 'primeng/fileupload';
import { MessageModule } from 'primeng/message';
import { ChipModule } from 'primeng/chip';

@NgModule({
	declarations: [],
	imports: [
		CommonModule,
		BlockUIModule,
		ButtonModule,
		CalendarModule,
		CardModule,
		CheckboxModule,
		ConfirmPopupModule,
		DropdownModule,
		DynamicDialogModule,
		InputNumberModule,
		InputSwitchModule,
		InputTextModule,
		MenuModule,
		ProgressBarModule,
		ProgressSpinnerModule,
		RippleModule,
		ScrollPanelModule,
		SidebarModule,
		TableModule,
		TabMenuModule,
		ToastModule,
		RadioButtonModule,
		CarouselModule,
		ChartModule,
		DialogModule,
		InputTextareaModule,
		OverlayPanelModule,
		PanelModule,
		PanelMenuModule,
		PasswordModule,
		PickListModule,
		SelectButtonModule,
		SliderModule,
		EditorModule,
		GalleriaModule,
		TreeTableModule,
		AccordionModule,
		AutoCompleteModule,
		AvatarModule,
		ImageModule,
		MultiSelectModule,
		RatingModule,
		ScrollTopModule,
		TagModule,
		BreadcrumbModule,
		StepsModule,
		SkeletonModule,
		DragDropModule,
		CascadeSelectModule,
		DividerModule,
		StepperModule,
		MessagesModule,
		FileUploadModule,
		MessageModule,
		ChipModule,
	],
	exports: [
		BlockUIModule,
		ButtonModule,
		CalendarModule,
		CardModule,
		CheckboxModule,
		ConfirmPopupModule,
		DropdownModule,
		DynamicDialogModule,
		InputNumberModule,
		InputSwitchModule,
		InputTextModule,
		MenuModule,
		ProgressBarModule,
		ProgressSpinnerModule,
		RippleModule,
		ScrollPanelModule,
		SidebarModule,
		TableModule,
		TabMenuModule,
		ToastModule,
		RadioButtonModule,
		CarouselModule,
		ChartModule,
		DialogModule,
		InputTextareaModule,
		OverlayPanelModule,
		PanelModule,
		PanelMenuModule,
		PasswordModule,
		PickListModule,
		SelectButtonModule,
		SliderModule,
		EditorModule,
		GalleriaModule,
		TreeTableModule,
		AccordionModule,
		AutoCompleteModule,
		AvatarModule,
		ImageModule,
		MultiSelectModule,
		RatingModule,
		ScrollTopModule,
		TagModule,
		BreadcrumbModule,
		StepsModule,
		SkeletonModule,
		DragDropModule,
		CascadeSelectModule,
		DividerModule,
		StepperModule,
		MessagesModule,
		FileUploadModule,
		MessageModule,
		ChipModule,
	],
})
export class AppPrimengModule {}
